import { render, staticRenderFns } from "./SalariesDeatials.vue?vue&type=template&id=2ac97736"
import script from "./SalariesDeatials.vue?vue&type=script&lang=js"
export * from "./SalariesDeatials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports